export enum NotificationParam {
  // Whether the notification should also display as a toast
  SHOULD_TOAST = 'shouldToast'
}
